/* tslint:disable:no-unused-variable */
import { Injectable } from '@angular/core';
import { Observable, Observer, forkJoin } from 'rxjs';
import { LoggingService } from './../logging/logging.service';
import { LoggingConstants } from './../../constants/logging-constant';
import { DomStorageFallbackService } from './../DomStorageFallback.service';
import { AppUtility } from './../../utils/utility';
import { AppConstants } from './../../constants/app-constants';

// @dynamic
@Injectable()
export class IDBService {
    public static idbDatabaseObj: IDBDatabase;
    private db: IDBDatabase;
    private curDatabase: IDBDatabase;
    public idbStoreList: any[] = [];

    /* istanbul ignore next */
    constructor(private loggingService: LoggingService, private domStorageFB: DomStorageFallbackService, private appUtility: AppUtility) { }

    /* istanbul ignore next */
    public openDB(dbName: string, table: string, version?: number) {
        let self = this;
        return new Observable((observer: Observer<string>) => {
            // Opens the database.
            let request: IDBOpenDBRequest;
            if (IDBService && IDBService.idbDatabaseObj && IDBService.idbDatabaseObj.version >= version) {
                AppConstants.INDEX_DB_VERSION = IDBService.idbDatabaseObj.version + 1;
                version = AppConstants.INDEX_DB_VERSION;
            }
            try {
                if (version == null) {
                    request = indexedDB.open(dbName);
                } else {
                    request = indexedDB.open(dbName, version);
                }
            } catch (error) {
                if (LoggingService.uConsole) {
                    console.log('IndexedDB object is not supported in browser ', error);
                }
                LoggingConstants.IS_IDB_ENABLED_IN_BROWSER = false;
                observer.next('');
                observer.complete();
            }
            // Success event.
            request.onsuccess = (event: Event) => {
                if (LoggingService.uConsole) {
                    console.log('IDB DB opened successfully.' + (<IDBOpenDBRequest>event.target).result);
                }
                LoggingConstants.IS_IDB_ENABLED_IN_BROWSER = true;
                // Setting global IDB variable for checking Indexed db is enabled or not in browser.
                this.loggingService._debug('IDBService.openDB() - IDB DB opened successfully. ' + event, 'UI Core ', LoggingConstants.INFO);
                // Instances the db object.
                self.db = event.target['result'];

                self.db.onversionchange = function (event1) {
                    if (self.db) {
                        self.db.close();
                    }
                };
                self.curDatabase = (<IDBOpenDBRequest>event.target).result;
                IDBService.idbDatabaseObj = (<IDBOpenDBRequest>event.target).result;
                self.setDBName((<IDBOpenDBRequest>event.target).result);

                self.curDatabase.onversionchange = function (event2) {
                    if (self.curDatabase) {
                        self.curDatabase.close();
                    }
                    if (IDBService.idbDatabaseObj) {
                        IDBService.idbDatabaseObj.close();
                    }
                };
                observer.next((<IDBOpenDBRequest>event.target).readyState);
                observer.complete();
            };

            // Error.
            request.onerror = (event: Event) => {
                if (LoggingService.uConsole) {
                    console.log('On error event while creation of ndexedDB ', event);
                }
                LoggingConstants.IS_IDB_ENABLED_IN_BROWSER = false;
                // Setting global IDB variable for checking Indexed db is enabled or not in browser.
                this.loggingService._debug('IDBService.openDB() - On error event indexedDB. ' + event, ' UI Core ', LoggingConstants.INFO);
                try {
                    if (self.db) {
                        self.db.close();
                    }
                    if (self.curDatabase) {
                        self.curDatabase.close();
                    }
                    if (IDBService.idbDatabaseObj) {
                        IDBService.idbDatabaseObj.close();
                    }
                } catch (e) {
                    if (LoggingService.uConsole) {
                        console.log('Error opening indexedDB ', e);
                    }
                    this.loggingService._debug('IDBService.openDB() - On error event indexedDB. ' + e, ' UI Core ', LoggingConstants.INFO);
                }
                self.curDatabase = null;
                observer.error((<IDBOpenDBRequest>event.target).error.name);
            };

            request.onblocked = (event: Event) => {
                if (LoggingService.uConsole) {
                    console.log('On blocked event indexedDB ', event);
                }
                this.loggingService._debug('IDBService.openDB() - On blocked event indexedDB. ' + event, ' UI Core ', LoggingConstants.INFO);
                try {
                    if (self.db) {
                        self.db.close();
                    }
                    if (self.curDatabase) {
                        self.curDatabase.close();
                    }
                    if (IDBService.idbDatabaseObj) {
                        IDBService.idbDatabaseObj.close();
                    }
                } catch (e) {
                    if (LoggingService.uConsole) {
                        console.log('Error in On blocked event indexedDB ', e);
                    }
                    this.loggingService._debug('IDBService.openDB() - On blocked event indexedDB. ' + e, ' UI Core ', LoggingConstants.INFO);
                }
                self.curDatabase = null;
                self.db = null;

            };

            // The db  exist, so update it it.
            request.onupgradeneeded = (event: Event) => {
                if (LoggingService.uConsole) {
                    console.log('On upgrade event indexedDB ', event);
                }
                this.loggingService._debug('IDBService.openDB() - On upgrade event indexedDB. ' + event, ' UI Core ', LoggingConstants.INFO);
                // Instances the db object.
                self.db = event.target['result'];
                self.curDatabase = event.target['result'];

                IDBService.idbDatabaseObj = event.target['result'];

                self.createStores(IDBService.idbDatabaseObj, table);

                IDBService.idbDatabaseObj.onversionchange = function (event2) {
                    if (self.db) {
                        self.db.close();
                    }
                    if (self.curDatabase) {
                        self.curDatabase.close();
                    }
                    if (IDBService.idbDatabaseObj) {
                        IDBService.idbDatabaseObj.close();
                    }
                    if (LoggingService.uConsole) {
                        console.log(`IDB DB Version Change., ${event2}, IDBService.idbDatabaseObj ${IDBService.idbDatabaseObj},self.curDatabase. ${self.curDatabase}`);
                    }
                };
            };

        });
    }


    /**
        * Gets the object store.
        *
        * @param storeName The name of the object store
        * @param mode Transaction mode
        * @return The object store
     */
    /* istanbul ignore next */
    private getObjectStore(storeName: string, mode: any) {
        if (LoggingService.uConsole) {
            console.log('In IDBService.getObjectStore() ', storeName, mode, IDBService.idbDatabaseObj, 'this.db', this.db);
        }
        try {
            // let tx: IDBTransaction = this.db.transaction(storeName, mode);
            let tx: IDBTransaction = IDBService.idbDatabaseObj.transaction(storeName, mode);
            if (LoggingService.uConsole) {
                console.log('In IDBService.getObjectStore() tx', tx);
            }

            tx.oncomplete = function (event) {
                if (LoggingService.uConsole) {
                    console.log('In getObjectStore :: transaction completed for store ', storeName, event);
                }
            };

            tx.onerror = function (event) {
                if (LoggingService.uConsole) {
                    console.log('In getObjectStore ::transaction error for:: ', storeName, event);
                }
            };
            tx.onabort = function (event) {
                if (LoggingService.uConsole) {
                    console.log('In getObjectStore ::transaction aborted for store ', storeName, event);
                    console.log('In getObjectStore Erro Desp:: ', (<DOMException>tx.error));
                    console.log('In getObjectStore Transaction obj:: ', tx);
                }
            };
            return tx.objectStore(storeName);
        } catch (err) {
            if (LoggingService.uConsole) {
                console.log('IDBService.getObjectStore() - Error getting object store ', err);
            }
            this.loggingService._debug('IDBService.getObjectStore() - Error getting object store ' + err, ' UI Core ', LoggingConstants.INFO);
            return null;
        }
    }

    /**
       * Adds record in Object Store
       *
       * @param storeName The name of the object store
       * @return The object store
    */
    /* istanbul ignore next */
    public addRecordsInObjStore(storeName: string, record: any, key: string) {
        // Gets the object store.
        // Gets the object store.
        if (LoggingService.uConsole) {
            console.log('IDBService.addRecordFromObjStore() ', storeName, record, key);
        }
        let store: IDBObjectStore = this.getObjectStore(storeName, 'readwrite');
        if (store !== null && store !== undefined) {
            return new Observable((observer: Observer<string>) => {
                try {
                    const request: IDBRequest = store.put(record, key); // Adds a new record.
                    // Success.
                    request.onsuccess = (event: Event) => {
                        if (LoggingService.uConsole) {
                            console.log('IDBService.addRecordFromObjStore() ', storeName, record, key, event);
                        }
                        this.updateIdbPopulatedStoreNames(storeName);
                        observer.next((<IDBRequest>event.target).readyState);
                        observer.complete();
                    };
                    // Error.
                    request.onerror = (event: Event) => {
                        if (LoggingService.uConsole) {
                            console.log('IDBService.addRecordsInObjStore() - Error adding records object store ', storeName, record, key, event);
                        }
                        this.loggingService._debug('IDBService.addRecordsInObjStore() - Error adding records object store ' + event, ' UI Core ', LoggingConstants.INFO);
                        observer.error((<IDBRequest>event.target).error.name);
                    };
                } catch (error) {
                    if (LoggingService.uConsole) {
                        console.log('IDBService.addRecordsInObjStore() - Error in store.put', error);
                    }
                    observer.next('');
                    observer.complete();
                }
            });
        } else {
            return new Observable((observer) => {
                observer.next({});
                observer.complete();
            });
        }
    }

    /**
    * Delete records in Object Store.
    *
    * @param storeName The name of the object store
    * @return The object store
    */
    /* istanbul ignore next */
    public deleteRecordAsync(storeName: string, key: string) {
        // Gets the object store.
        let store: IDBObjectStore = this.getObjectStore(storeName, 'readwrite');
        if (store) {
            return new Observable((observer: Observer<string>) => {
                let request: IDBRequest = store.delete(key); // Deletes the record by the key.
                // Success.
                request.onsuccess = (event: Event) => {
                    observer.next((<IDBRequest>event.target).readyState);
                    observer.complete();
                };
                // Error.
                request.onerror = (event: Event) => {
                    if (LoggingService.uConsole) {
                        console.log('IDBService.deleteRecordAsync() - Error deleting records in object store ', storeName, key, event);
                    }
                    this.loggingService._debug('IDBService.deleteRecordAsync() - Error deleting records in object store ' + event, ' UI Core ', LoggingConstants.INFO);
                    observer.error((<IDBRequest>event.target).error.name);
                };
            });
        }
        // Returning blank Observalbe if store is not available
        return new Observable((observer) => {
            observer.next({});
            observer.complete();
        });
    }

    /**
       * Delete records in Object Store.
       *
       */
    /* istanbul ignore next */
    public clearObjectStore(storeName: string) {
        // Gets the object store.
        let store: IDBObjectStore = this.getObjectStore(storeName, 'readwrite');
        if (store == null) {
            return new Observable((observer: Observer<string>) => {
                observer.next('');
                observer.complete();
            });
        }
        return new Observable((observer: Observer<string>) => {
            let request: IDBRequest = store.clear(); // Clears the object store.
            // Success.
            request.onsuccess = (event: Event) => {
                observer.next((<IDBRequest>event.target).readyState);
                observer.complete();
            };
            // Error.
            request.onerror = (event: Event) => {
                if (LoggingService.uConsole) {
                    console.log('IDBService.clearObjectStore() - Error clearing object store ', storeName, event);
                }
                this.loggingService._debug('IDBService.clearObjectStore() - Error clearing object store ' + event, ' UI Core ', LoggingConstants.INFO);
                observer.error((<IDBRequest>event.target).error.name);
            };
        });
    }

    /*Creates new store in db specified & Table name given*/

    /* istanbul ignore next */
    private createStores(db: IDBDatabase, table: string) {
        try {
            if (LoggingService.uConsole) {
                console.log('In create stores method ', this.idbStoreList);
            }
            /*        db.createObjectStore(table);
                      db.createObjectStore("tiles");
                      db.createObjectStore("header");
                      db.createObjectStore("searchwidget");
                      db.createObjectStore("footer"); */

            if (this.idbStoreList && this.idbStoreList.length) {
                this.idbStoreList.forEach((element, index) => {
                    if (LoggingService.uConsole) {
                        console.log('store creating for :: ', element);
                    }
                    if (db && !db.objectStoreNames.contains(element) && this.idbStoreList.indexOf(element) === index) {
                        db.createObjectStore(element);
                    }
                }); // assign the data from subscription to your class variable
            }
            if (db && table && !db.objectStoreNames.contains(table)) {
                if (LoggingService.uConsole) {
                    console.log('IDBService.createStores() - Creating store', table);
                }
                db.createObjectStore(table);
            }
            if (LoggingService.uConsole) {
                console.log('IDBService.createStores() - All required stores have been created successfully');
            }

        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('IDBService.createStores() - Error creating object store ', db, table, error);
            }
            this.loggingService._debug('IDBService.createStores() - Error creating object store ' + error, ' UI Core ', LoggingConstants.INFO);
        }
    }

    /**
     * get record in Object Store
     *
     * @param storeName The name of the object store
     * @return The object store
     */

    /* istanbul ignore next */
    public getRecordFromObjStore(storeName: string, key: string) {
        // Gets the object store.
        if (LoggingService.uConsole) {
            console.log('IDBService.getRecordFromObjStore()', storeName, key);
        }
        let store: IDBObjectStore = this.getObjectStore(storeName, 'readonly');
        return new Observable((observer: Observer<string>) => {
            let request: IDBRequest = store.get(key); // Adds a new record.
            // Success.
            request.onsuccess = (event: Event) => {
                if (LoggingService.uConsole) {
                    console.log('IDBService.getRecordFromObjStore() - Key found successfully', storeName, key, event.target['result']);
                }
                observer.next(event.target['result']);
                observer.complete();
            };
            // Error.
            request.onerror = (event: Event) => {
                if (LoggingService.uConsole) {
                    console.log('IDBService.getRecordFromObjStore() - Error getting record from object store ', storeName, key, event);
                }
                this.loggingService._debug('IDBService.getRecordFromObjStore() - Error getting record from object store ' + event, 'UI Core', LoggingConstants.INFO);
                observer.error((<IDBRequest>event.target).error.name);
            };
        });
    }

    /*Edit records*/

    /* istanbul ignore next */
    public editRecord(storeName: string, value: any, key: string) {
        // Gets the object store.
        let store: IDBObjectStore = this.getObjectStore(storeName, 'readwrite');
        return new Observable((observer: Observer<string>) => {
            let request: IDBRequest = store.put(value, key); // Puts the updated record back into the database.
            // Success.
            request.onsuccess = (event: Event) => {
                observer.next((<IDBRequest>event.target).readyState);
                observer.complete();
            };
            // Error.
            request.onerror = (event: Event) => {
                if (LoggingService.uConsole) {
                    console.log('IDBService.editRecord() - Error editing record from object store ', storeName, value, key, event);
                }
                this.loggingService._debug('IDBService.editRecord() - Error editing record from object store ' + event, ' UI Core ', LoggingConstants.INFO);
                observer.error((<IDBRequest>event.target).error.name);
            };
        });
    }

    /*set DBNAME */

    /* istanbul ignore next */
    public getDBName() {
        if (LoggingService.uConsole) {
            console.log('IDBService.getDBName() ', this.curDatabase);
            console.log('IDBService.getDBName() IDBService.idbDatabaseObj ', IDBService.idbDatabaseObj);
        }
        this.loggingService._debug('IDBService.getDBName() ' + this.curDatabase, ' UI Core ', LoggingConstants.INFO);
        // return this.curDatabase;
        return IDBService.idbDatabaseObj;
    }

    /* istanbul ignore next */
    public setDBName(updatedDBObj: IDBDatabase) {
        if (LoggingService.uConsole) {
            console.log('IDBService.setDBName() ', updatedDBObj);
        }
        this.loggingService._debug('IDBService.setDBName() ' + updatedDBObj, ' UI Core ', LoggingConstants.INFO);
        this.curDatabase = updatedDBObj;
    }

    /**
     * Clearing all stores of IDB storage.
     * Clearing local cache purpose
     */

    /* istanbul ignore next */
    public clearALL_IDBStores() {
        if (LoggingService.uConsole) {

            console.log('Started IDBService.clearALL_IDBStores()');
        }
        let obsArray = [];
        let storeArray = [];
        let indexDbObj: IDBDatabase;
        // PCA-7016  for loadertextconfig call on language change
        this.domStorageFB.removeItem('loaderValue', 'localStorage', true);

        if (this.curDatabase || this.db || IDBService.idbDatabaseObj) {
            indexDbObj = (this.curDatabase || this.db || IDBService.idbDatabaseObj);
        }
        if (indexDbObj) {
            // this.debugView(indexDbObj, 'in store clear loop');
            let objectStoreList = indexDbObj.objectStoreNames;
            for (let _i = 0; _i < objectStoreList.length; _i++) {
                storeArray.push(objectStoreList[_i]);
            }

            // this.debugView(storeArray, 'storeArray');
            for (let store of Object.keys(storeArray)) {
                // this.debugView(storeArray[store], 'Clearing store clear');
                obsArray.push(this.clearObjectStore(storeArray[store]));
            }
            forkJoin(obsArray).subscribe((val) => {
                // this.debugView(val, 'Indexed DB stores is cleared successfully ');
            }, err => {
                if (LoggingService.uConsole) {
                    console.log('Error in IDBService.clearALL_IDBStores() ', err);
                }
                this.loggingService._debug('Error in IDBService.clearALL_IDBStores() ' + err, ' UI Core ', LoggingConstants.INFO);
            });
        } else {
            this.clearIndexedDBstore_LR();
        }
    }



    /**
     * swEnabledFlag - is passed for service worker case only to partial clear indexedDB, refer clearIndexedDBstore_SW()
     */

    /* istanbul ignore next */
    private clearIndexedDBstore_LR(swEnabledFlag?: boolean) {
        try {
            if (LoggingService.uConsole) {
                console.log('IDBService| clearIndexedDBstore_LR() started...');
            }
            let IDB = window.indexedDB || (<any>window).mozIndexedDB || (<any>window).webkitIndexedDB || (<any>window).msIndexedDB;
            let Upoint_DBObj: IDBOpenDBRequest;

            Upoint_DBObj = IDB.open('Upoint_DB');

            Upoint_DBObj.onsuccess = (event) => {

                let Upoint_DBTrans = Upoint_DBObj.result;
                let Upoint_DBStoreList = Upoint_DBObj.result.objectStoreNames;

                for (let i = 0; i < Upoint_DBStoreList.length; i++) {
                    try {
                        // UFD-1558
                        if (swEnabledFlag && swEnabledFlag === true && this.appUtility.isSwFeatureEnabled() && this.appUtility.isSWFeatureEnabledForStore(Upoint_DBStoreList[i])) {
                            if (LoggingService.uConsole) {
                                console.log('IDBService| clearIndexedDBstore_LR() - Skip store for cleanup -', Upoint_DBStoreList[i]);
                            }
                            // Commented out the below block as not needed - refer Story UFD-5004
                            // handling removal or hiding data tiles
                            // if (Upoint_DBStoreList[i] === 'tiles') {
                            //     if (LoggingService.uConsole) {
                            //         console.log('******************* IDBService| clearALL_IDBStores_LR() - Inside TilesFlow');
                            //     }
                            //     this.updateTileStore_SW();  // Update Tile store for data tiles
                            // }
                            continue;
                        }
                        if (LoggingService.uConsole) {
                            console.log('IDBService| clearIndexedDBstore_LR() - Add store for cleanup -', Upoint_DBStoreList[i]);
                        }
                        setTimeout(() => {
                            const request = Upoint_DBTrans.transaction([Upoint_DBStoreList[i]], 'readwrite').objectStore(Upoint_DBStoreList[i]).clear();
                        }, 150);
                    } catch (e) {
                        if (LoggingService.uConsole) {
                            console.log('Error in IDBService.clearIndexedDBstore_LR() ', e);
                        }
                        this.loggingService._debug('Error in IDBService.clearALL_IDBStores_LR() ' + e, ' UI Core ', LoggingConstants.INFO);
                    }
                }
            };

            Upoint_DBObj.onerror = (event: Event) => {
                if (LoggingService.uConsole) {
                    console.log('Error in IDBService.clearIndexedDBstore_LR() onerror event ', event);
                }
                this.loggingService._debug('Error in IDBService.clearIndexedDBstore_LR() onerror event ' + event, ' UI Core ', LoggingConstants.INFO);
            };
            Upoint_DBObj.onblocked = (event: Event) => {
                if (LoggingService.uConsole) {
                    console.log('Error in IDBService.clearIndexedDBstore_LR() onblocked event ', event);
                }
                this.loggingService._debug('Error in IDBService.clearIndexedDBstore_LR() onblocked event ' + event, ' UI Core ', LoggingConstants.INFO);
            };

        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('Error in IDBService.clearIndexedDBstore_LR() ', error);
            }
        }
    }


    /* istanbul ignore next */
    getAllRecordsAsync(storeName: string) {
        // Gets the object store.
        const store: IDBObjectStore = this.getObjectStore(storeName, 'readonly');

        return new Observable((observer: Observer<any>) => {

            const request: IDBRequest = store.openCursor();
            let indexDbData = new Map();
            let storeData = new Map();
            let storeDataArray: Array<string> = [];
            // Success.
            request.onsuccess = (event: Event) => {

                // Steps through all the values in the object store.
                const cursor: IDBCursorWithValue = (<IDBRequest>event.target).result;

                let storeDataJson = {};
                if (cursor) {
                    let indexDBJson = {};
                    indexDbData.set(cursor.key, cursor.value);
                    indexDbData.forEach(function (value, key) {
                        indexDBJson[key] = value;
                    });
                    storeDataArray.push(JSON.stringify(indexDBJson));
                    indexDbData.clear();
                    cursor.continue();
                } else {
                    // var storeJson = []
                    storeData.set(storeName, JSON.stringify(storeDataArray));
                    storeData.forEach(function (value, key) {
                        storeDataJson[key] = value;
                    });
                    observer.next(JSON.stringify(storeDataJson));
                    observer.complete();
                }
            };

            // Error.
            request.onerror = (event: Event) => {
                console.log('IndexedDB service: ' + (<IDBRequest>event.target).error.name);
                observer.error((<IDBRequest>event.target).error.name);
            };

        });

    }

      /* istanbul ignore next */
      public clearALL_IDBStores_SW() {
        // UFD-1558, UFD-2146
        if (LoggingService.uConsole) {
            console.log('IDBService| Started clearALL_IDBStores_SW()');
        }
        let obsArray = [];
        let storeArray = [];
        let indexDbObj: IDBDatabase;
        // PCA-7016  for loadertextconfig call on language change
        this.domStorageFB.removeItem('loaderValue', 'localStorage', true);

        if (this.curDatabase || this.db || IDBService.idbDatabaseObj) {
            indexDbObj = (this.curDatabase || this.db || IDBService.idbDatabaseObj);
        }
        if (indexDbObj) {
            // this.debugView(indexDbObj, 'in store clear loop');
            let objectStoreList = indexDbObj.objectStoreNames;
            for (let _i = 0; _i < objectStoreList.length; _i++) {

                // UFD-1558
                if (this.appUtility.isSwFeatureEnabled() && this.appUtility.isSWFeatureEnabledForStore(objectStoreList[_i])) {
                    if (LoggingService.uConsole) {
                        console.log('IDBService| clearALL_IDBStores_SW() - Skip store for cleanup -', objectStoreList[_i]);
                    }
                    // handling removal or hiding data tiles
                    // if (objectStoreList[_i] === 'tiles') {
                    //     if (LoggingService.uConsole) {
                    //         console.log('******************* IDBService| clearALL_IDBStores_SW() - Inside TilesFlow');
                    //     }
                    //     this.updateTileStore_SW();  // Update Tile store for data tiles
                    // }
                    continue;
                }
                if (LoggingService.uConsole) {
                    console.log('IDBService| clearALL_IDBStores_SW() - Add store for cleanup -', objectStoreList[_i]);
                }
                storeArray.push(objectStoreList[_i]);
            }

            // this.debugView(storeArray, 'storeArray');
            for (let store of Object.keys(storeArray)) {
                // this.debugView(storeArray[store], 'Clearing store clear');
                obsArray.push(this.clearObjectStore(storeArray[store]));
            }
            forkJoin(obsArray).subscribe((val) => {
                // this.debugView(val, 'Indexed DB stores is cleared successfully ');
            }, err => {
                if (LoggingService.uConsole) {
                    console.log('IDBService| Error in IDBService.clearALL_IDBStores_SW() ', err);
                }
                this.loggingService._debug('Error in IDBService.clearALL_IDBStores_SW() ' + err, ' UI Core ', LoggingConstants.INFO);
            });

            this.expire_ALLIDBStores_SW();
        } else {
            if (LoggingService.uConsole) {
                console.log('IDBService| clearALL_IDBStores_SW() - trigger clearIndexedDBstore_LR()');
            }
            this.clearIndexedDBstore_LR(true);
            this.expire_ALLIDBStores_LR_SW();
        }
    }

    /* istanbul ignore next */
    public expire_ALLIDBStores_LR_SW() {
        // UFD-1558, UFD-2146
        if (LoggingService.uConsole) {
            console.log('IDBService| expire_ALLIDBStores_LR_SW() started...');
        }
        try {
            let IDB = window.indexedDB || (<any>window).mozIndexedDB || (<any>window).webkitIndexedDB || (<any>window).msIndexedDB;
            let Upoint_DBObj: IDBOpenDBRequest;
            let db;
            let orgName = this.appUtility.getOrgName().toLowerCase(); // UFD-3872
            Upoint_DBObj = IDB.open('Upoint_DB');
            Upoint_DBObj.onsuccess = (event) => {
                db = Upoint_DBObj.result;
                try {
                    let storeNameArray = this.appUtility.getAllSWFeatureEnabledStoreNames();
                    for (let sKey of Object.keys(storeNameArray)) {
                        let storeName = storeNameArray[sKey];
                        let transaction = db.transaction([storeName], 'readwrite');
                        // report on the success of the transaction completing, when everything is done
                        transaction.oncomplete = function (event) {
                            if (LoggingService.uConsole) {
                                console.log('IDBService| expire_ALLIDBStores_LR_SW() - Transaction completed for store.');
                            }
                        };

                        transaction.onerror = function (event) {
                            if (LoggingService.uConsole) {
                                console.log(
                                    'IDBService| expire_ALLIDBStores_LR_SW() - Transaction not opened due to error on store: ',
                                    transaction.error
                                );
                            }
                        };
                        // create an object store on the transaction
                        let objectStore = transaction.objectStore(storeName);
                        let oldDate = new Date(Date.now() - 900 * 1000);
                        let currentDate = new Date();

                        let objectStoreRequest = objectStore.getAllKeys();
                        objectStoreRequest.onsuccess = function (event) {
                            let keyArr = event.target.result;
                            if (LoggingService.uConsole) {
                                console.log('IDBService| expire_ALLIDBStores_LR_SW() getAllKeys: ', storeName, keyArr);
                            }
                            if (keyArr) {
                                if (LoggingService.uConsole) {
                                    console.log('IDBService| expire_ALLIDBStores_LR_SW() - Processing Keys started.', storeName);
                                }
                                for (let key of Object.keys(keyArr)) {
                                    if (LoggingService.uConsole) {
                                        console.log('IDBService| expire_ALLIDBStores_LR_SW()- Processing key: ', storeName, keyArr[key]);
                                    }
                                    let dataRequest = objectStore.get(keyArr[key]);
                                    dataRequest.onsuccess = function (event1) {
                                        let data = event1.target.result;
                                        let isDataAlreadyExpired = false;
                                        if (LoggingService.uConsole) {
                                            console.log('IDBService| expire_ALLIDBStores_LR_SW() - ', keyArr[key], data);
                                        }

                                        if (data) {
                                            if (orgName && orgName !== null && orgName !== '') {
                                                if (data.swdataid) {
                                                    let swdatatidVal = data.swdataid;
                                                    if (swdatatidVal.indexOf(orgName) > -1) {
                                                        if (data.expires > currentDate) {
                                                            if (LoggingService.uConsole) {
                                                                console.log('IDBService| expire_ALLIDBStores_LR_SW() Initiate expiratin- ', keyArr[key]);
                                                            }
                                                            data.expires = oldDate;
                                                            let dataUpdateRequest = objectStore.put(data, keyArr[key]);
                                                            dataUpdateRequest.onsuccess = function (event2) {
                                                                if (LoggingService.uConsole) {
                                                                    console.log('IDBService| expire_ALLIDBStores_LR_SW() update data - ', keyArr[key]);
                                                                }
                                                            };
                                                        }
                                                    } else {
                                                        let delR = objectStore.delete(keyArr[key]);
                                                        delR.onsuccess = function (event2) {
                                                            //
                                                        };
                                                    }
                                                } else {
                                                    let delR = objectStore.delete(keyArr[key]);
                                                    delR.onsuccess = function (event2) {
                                                        //
                                                    };
                                                }
                                            } else {
                                                let delR = objectStore.delete(keyArr[key]);
                                                delR.onsuccess = function (event2) {
                                                    //
                                                };
                                            }
                                        }
                                    };
                                }
                            }
                        };
                    }
                } catch (error) {
                    if (LoggingService.uConsole) {
                        console.log('Error!!! in IDBService.expire_ALLIDBStores_LR_SW() ', error);
                    }
                }
            };
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('Error in IDBService.expire_ALLIDBStores_LR_SW() ', error);
            }
        }
    }
    /* istanbul ignore next */
    public expire_ALLIDBStores_SW() {
        // UFD-1558, UFD-2146
        if (LoggingService.uConsole) {
            console.log('IDBService| expire_ALLIDBStores_SW() started...');
        }
        try {
            let indexDbObj: IDBDatabase;
            if (this.curDatabase || this.db || IDBService.idbDatabaseObj) {
                indexDbObj = (this.curDatabase || this.db || IDBService.idbDatabaseObj);
            }
            if (indexDbObj) {
                let oldDate = new Date(Date.now() - 900 * 1000);
                let currentDate = new Date();

                let orgName = this.appUtility.getOrgName().toLowerCase(); // UFD-3872
                let objectStoreList = this.appUtility.getAllSWFeatureEnabledStoreNames();
                for (let _i = 0; _i < objectStoreList.length; _i++) {
                    let storeName = objectStoreList[_i];
                    if (LoggingService.uConsole) {
                        console.log('IDBService| expire_ALLIDBStores_SW() - Processing Keys started.', storeName);
                    }

                    let store: IDBObjectStore = this.getObjectStore(storeName, 'readwrite');
                    const request: IDBRequest = store.openCursor();
                    request.onsuccess = (event: Event) => {
                        if (LoggingService.uConsole) {
                            console.log('IDBService| expire_ALLIDBStores_SW() - Cursor opened for store: ', storeName);
                        }
                        const cursor: IDBCursorWithValue = (<IDBRequest>event.target).result;
                        if (cursor) {
                            if (LoggingService.uConsole) {
                                console.log('IDBService| expire_ALLIDBStores_SW() - Cursor checking key: ', storeName, cursor.key);
                            }
                            if (orgName && orgName !== null && orgName !== '') {
                                if (cursor.value && cursor.value['swdataid']) {
                                    let swdatatidVal = cursor.value['swdataid'];
                                    if (swdatatidVal.indexOf(orgName) > -1) {
                                        if (cursor.value && cursor.value['expires']) {
                                            if (cursor.value['expires'] > currentDate) {
                                                if (LoggingService.uConsole) {
                                                    console.log('IDBService| expire_ALLIDBStores_SW() Initiate expiration- ', cursor.key);
                                                }
                                                cursor.value['expires'] = oldDate;
                                                cursor.update(cursor.value);
                                                if (LoggingService.uConsole) {
                                                    console.log('IDBService| expire_ALLIDBStores_SW() update data - ', storeName, cursor.key);
                                                }
                                            }
                                        }
                                    } else {
                                        // delete if swdataid does not have cleintid
                                        let delR = cursor.delete();
                                        delR.onsuccess = function () {
                                            //
                                        };
                                    }
                                } else {
                                    // delete if swdataid does not exists
                                    let delR = cursor.delete();
                                    delR.onsuccess = function () {
                                        //
                                    };
                                }
                            } else {
                                // delete if swdataid does not exists
                                let delR = cursor.delete();
                                delR.onsuccess = function () {
                                    //
                                };
                            }
                            cursor.continue();
                        }
                    };
                }
            }

        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('Error in IDBService.expire_ALLIDBStores_SW() ', error);
            }
        }
    }

    /* istanbul ignore next */
    updateTileStore_SW() {
        // UFD-3095
        if (LoggingService.uConsole) {
            console.log('IDBService| updateTileStore_SW() started...');
        }
        try {
            // Gets the object store.
            const store: IDBObjectStore = this.getObjectStore('tiles', 'readwrite');
            const request: IDBRequest = store.openCursor();
            let groupTileInfo = {};
            // Success.
            // const dataTileElements: any = {};
            // dataTileElements.data = {
            //             'contents': ['planName', 'tileTitle', 'elementtitle', 'text', 'text1', 'text2', 'text3', 'text4', 'text5', 'text6', 'ageText', 'avgPerfVal', 'poorPerfVal', 'goalTxt', 'goalVal', 'feInfo', 'headerText', 'supportingText']
            //         };
            // const elemContent = dataTileElements.data.contents;

            const tilestructuralElements: any = {};
            tilestructuralElements.data = {
                'contents': ['treatment', 'aonRedesignEnableForNonDataTile', 'tileid', 'tiletypecss', 'tileColor', 'tileGrpName', 'linkOnClick', 'isLazyLoad',
                'title', 'linkHref', 'linkTitle', 'tileType', 'isMaskable', 'templateName', 'tileTechnicalName', 'baseClntInd',
                'aonUpointRedesignEnable', 'namespace', 'Domain', 'TileNm', 'tileEyeImageTitle', 'imageURL', 'isSupportedTemp']
            };
            const structuralElement = tilestructuralElements.data.contents;
            request.onsuccess = (event: Event) => {
                if (LoggingService.uConsole) {
                    console.log('IDBService| updateTileStore_SW() - Cursor opened for store:');
                }
                const cursor: IDBCursorWithValue = (<IDBRequest>event.target).result;
                if (cursor) {
                    if (LoggingService.uConsole) {
                        console.log('IDBService| updateTileStore_SW() - Cursor checking key: ' + cursor.key);
                    }
                    if (cursor.value && cursor.value['value'][0]['tileResponse']) {
                        groupTileInfo = cursor.value['value'][0]['tileResponse'];
                        // if (groupTileInfo['dataTile']) {
                            if (LoggingService.uConsole) {
                                console.log('IDBService| updateTileStore_SW - Data Tile detected in TileGroup : ' + cursor.key);
                            }
                            for (let _j = 0; _j < groupTileInfo['cellModal'].length; _j++) {
                                for (let _k = 0; _k < groupTileInfo['cellModal'][_j].length; _k++) {
                                    for (let _l = 0; _l < groupTileInfo['cellModal'][_j][_k]['tileList'].length; _l++) {
                                        let tileInfo = groupTileInfo['cellModal'][_j][_k]['tileList'][_l];
                                        // if (tileInfo['isdatatile'] !== undefined && tileInfo['isdatatile'] === 'true') {
                                            let tilename = tileInfo['TileNm'];
                                            if (LoggingService.uConsole) {
                                                console.log('IDBService| updateTileStore_SW - Detected Data Tile Name is : ' + tilename);
                                            }
                                            // Logic to remove data tile incase of Lazyload enabled
                                            if (tileInfo['isLazyLoad'] !== undefined && tileInfo['isLazyLoad']) {
                                                this.deleteRecordAsync('tiles', tilename);
                                            }
                                            // Update data tile elements as blank
                                            // for (let element of elemContent) {
                                            //     if (tileInfo[element] !== undefined) {
                                            //         tileInfo[element] = '';
                                            //     }
                                            //     if (tileInfo['hide' + element] !== undefined) {
                                            //         tileInfo['hide' + element] = '';
                                            //     }
                                            // }
                                            for (const key of Object.keys(tileInfo)) {
                                                let dataElement: boolean = false;
                                                for (let element of structuralElement) {
                                                    if (key === element) {
                                                        dataElement = true;
                                                        break;
                                                    }
                                                }
                                                if (!dataElement) {
                                                    tileInfo[key] = '';
                                                }
                                              }
                                        // }
                                    }
                                }
                            }
                            cursor.value['value'][0]['tileResponse'] = groupTileInfo;
                            cursor.update(cursor.value);
                    // }
                }
                cursor.continue();
                }
            };
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('Error in IDBService.updateTileStore_SW() ', error);
            }
        }
    }
    /* istanbul ignore next */
    public clearSpecificIDBStores() {
        if (LoggingService.uConsole) {
            console.log('Started IDBService.clearSpecificIDBStores()');
        }
        let storec = this.getUniqueIdbPopulatedStoreNames();
        if (storec) {
            let startTimeReq = new Date().getTime();
            let obsArray = [];
            let indexDbObj: IDBDatabase;
            // PCA-7016  for loadertextconfig call on language change
            this.domStorageFB.removeItem('loaderValue', 'localStorage', true);
            if (this.curDatabase || this.db || IDBService.idbDatabaseObj) {
                indexDbObj = (this.curDatabase || this.db || IDBService.idbDatabaseObj);
            }
            if (indexDbObj) {
                for (const s of storec) {
                    obsArray.push(this.clearObjectStore(s));
                }

                forkJoin(obsArray).subscribe((val) => {
                    if (LoggingService.uConsole) {
                        console.log('IDBService.clearSpecificStores() - forkJoin val', val);
                    }
                    this.domStorageFB.removeItem('idbPopulatedStoreNames');
                    this.domStorageFB.setItem('indexdbCleared', 'true');
                }, err => {
                    if (LoggingService.uConsole) {
                        console.log('Error in IDBService.clearSpecificStores() ', err);
                    }
                    this.loggingService._error('Error in IDBService.clearSpecificStores() ' + err, ' UI Core ', LoggingConstants.ERROR);
                });
            }
        }
    }

    /* istanbul ignore next */
    updateIdbPopulatedStoreNames(storeName: string): void {
        let defaultStores = ['header', 'tiles', 'footer'];
        try {
            if (storeName && storeName !== '' && defaultStores.indexOf(storeName) <= -1) {
                let a = this.domStorageFB.getItem('idbPopulatedStoreNames');
                if (a) {
                    if (a.indexOf('|' + storeName + '|') <= -1) {
                        this.domStorageFB.setItem('idbPopulatedStoreNames', a + storeName + '|');
                    }

                } else {
                    this.domStorageFB.setItem('idbPopulatedStoreNames', '|' + storeName + '|');
                }
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('IDBService | updateIdbPopulatedStoreNames() - Error while updating store', storeName, error);
            }

        }
    }

    /* istanbul ignore next */
    getUniqueIdbPopulatedStoreNames(): any {
        let resp = ['header', 'tiles', 'footer'];

        try {
            let a = this.domStorageFB.getItem('idbPopulatedStoreNames');
            if (a) {
                let arr = a.split('|');
                for (let ii = 0; ii < arr.length; ii++) {
                    if (arr[ii] && arr[ii] !== '' && resp.indexOf(arr[ii]) <= -1) {
                        resp.push(arr[ii]);
                    }
                }

            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('IDBService | getUniqueIdbPopulatedStoreNames() - Error while getting store', error);
            }

        }

        return resp;

    }

}

